'use strict';

const DiagramActionCreator = require('system/domain/action/diagram');
const DirectoryView = require('system/ui/view/diagram/directory');
const Template = require('system/ui/template/diagram/directory-edit.hbs');
const i18n = require('i18next');
const Dialog = require('common/util/dialog');

module.exports = DirectoryView.extend({
    template: Template,
    events: {
        'click > .list-item-icon': 'toggle',
        'click > .list-item-content': 'toggle',
        'click > .list-item-content input.name': 'name',
        'click > .list-item-content .edit': 'edit',
        'click > .list-item-content .save': 'save',
        'click > .list-item-content .cancel': 'cancel',
        'click > .list-item-content .delete': 'deleteConfirm'
    },
    modelEvents: {
        'change:open': 'changeOpen',
        'change:edit': 'render'
    },
    bindings: {
        'input.name': 'name'
    },
    onRender: function () {
        if (!this.model.get('edit')) {
            this.$el.droppable({
                hoverClass: 'is-highlighted',
                greedy: true,
                drop: (event, ui) => {
                    var view = $(ui.draggable).data('backbone-view');
                    if (!view) {
                        return;
                    }
                    var m = view.model;
                    if (m.get('directory')) {
                        this.onDropDirectory(m);
                    } else {
                        this.onDropDiagram(m);
                    }
                }
            });

            this.$el.draggable({
                revert: true,
                revertDuration: 200,
                axis: 'y',
                zIndex: 100000
            });

            $(this.el).data('backbone-view', this);
        } else {
            this.stickit(this.model);
        }

        this.changeOpen();
    },

    onDropDiagram: function (diagram) {
        this.collection.chain()
            .filter(function (m) {
                return m.get('directory');
            })
            .each(function (d) {
                var diagrams = d.get('diagrams');
                if (_.contains(diagrams, diagram.id)) {
                    d.set({diagrams: _.without(diagrams, diagram.id)});
                }
            });

        // event 内で呼ぶと collectionView の render が走ってしまい、この View が無くなる。
        // そうなると親の droppable にも drop されたと勘違いしてエラーが起きるので setTimeout でずらす
        setTimeout(() => {
            var j = this.model.toJSON();
            j.diagrams.push(diagram.id);
            DiagramActionCreator.updateDirectory(
                this._context.projectId,
                this.model.id,
                j
            );
            this.model.get('diagrams').push(diagram.id);
            this.model.trigger('change:diagrams');
        }, 1);
    },

    onDropDirectory: function (directory) {
        directory.set({parentDirectory: this.model.id});
        DiagramActionCreator.updateDirectory(
            this._context.projectId,
            directory.id,
            {
                parentDirectory: this.model.id
            }
        );
    },

    name: function (e) {
        e.stopPropagation();
    },

    edit: function (e) {
        e.stopPropagation();
        this.model.set({original: this.model.toJSON()});
        this.model.set({edit: true});
    },

    cancel: function (e) {
        e.stopPropagation();
        if (this.model.get('creating')) {
            // 作りたてなので削除する
            this.model.trigger('destroy', this.model);
        } else {
            this.model.set(this.model.get('original'));
            this.model.set({edit: false});
        }
    },

    save: function (e) {
        e.stopPropagation();
        if (this.model.get('creating')) {
            var deferred = DiagramActionCreator.createDirectory(
                this._context.projectId,
                this.model.toJSON()
            );
            deferred.then(() => {
                this.model.trigger('destroy', this.model);
            });
        } else {
            var deferred = DiagramActionCreator.updateDirectory(
                this._context.projectId,
                this.model.id,
                this.model.toJSON()
            );
            deferred.then(() => {
                this.model.set({edit: false});
            });
        }
    },

    deleteConfirm: function(e) {
        if (this.model.get('diagrams').length == 0) {
            Dialog.confirm({
                text: i18n.t('notify.delete-confirm', {name: this.model.get('name')}),
                okCallback: () => {
                    this.delete();
                }
            });
        } else {
            Dialog.alert({
                text: i18n.t('balus_template_body_diagram:nav.delete-directory.alert', {name: this.model.get('name')})
            });
        }
        e.stopPropagation();
    },

    delete: function () {
        var deferred = DiagramActionCreator.deleteDirectory(
            this._context.projectId,
            this.model.id
        );

        var collection = this.collection;
        deferred.then(() => {
            this.model.set({edit: false});
            collection.chain()
                .filter(function (m) {
                    return m.get('directory');
                })
                .each(function (d) {
                    if (d.get('parentDirectory') == this.model.id) {
                        d.set({parentDirectory: this.model.get('parentDirectory')});
                    }
                }, this);
            if (this.model.get('parentDirectory')) {
                var p = collection.get(this.model.get('parentDirectory'));
                p.set({diagrams: _.union(p.get('diagrams'), this.model.get('diagrams'))})
            }
        });
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/diagram/directory-edit.js